import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import FancyHeading from '@/components/FancyHeading';
import Prose from '@/components/Prose';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import pageQuery from '@/graphql/queries/page';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';

export default function LegalPage({ breadcrumbs, page, mainLayout }) {
  let { contentSection, metaData } = page.attributes;
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <motion.div
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <BreadcrumbsBlock items={breadcrumbs} variants={fadeIn} />
        <section className="my-16 px-4">
          <div className="container-screen">
            <FancyHeading variants={fadeInUp}>{page.attributes.shortName}</FancyHeading>
            <Prose className="mt-16 max-w-full" variants={fadeInUp}>
              <Markdown>{contentSection[0].editorContent}</Markdown>
            </Prose>
          </div>
        </section>
      </motion.div>
    </FullWidthLayout>
  );
}

export async function getServerSideProps(req, res) {
  const page = pages.termsAndConditions;

  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(pageQuery, { slug: 'terms-and-conditions' });
  return {
    props: {
      breadcrumbs: [pages.home, page],
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    // revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
